// Single source of truth for the API host.
//
// Defaults to production. Set REACT_APP_API_BASE in the Vercel project (or a
// local .env) to point the admin panel elsewhere — e.g. an ngrok tunnel to a
// local backend during an outage — without a code change per URL.
export const API_BASE =
  (process.env.REACT_APP_API_BASE || 'https://api.gardenoai.com/api/v1').replace(/\/+$/, '');

// ngrok's free tier serves an HTML interstitial to requests that lack this
// header, which turns every fetch() into a JSON parse error. Harmless for the
// real API, which ignores it.
export const API_EXTRA_HEADERS: Record<string, string> = { 'ngrok-skip-browser-warning': '1' };
